/** One-shot gate so `/portal/add-device/success` is only reachable after checkout. */
export const ADD_DEVICE_ORDER_SUCCESS_KEY = "addDeviceOrderSuccess";

export const setAddDeviceOrderSuccessGate = (): void => {
  sessionStorage.setItem(ADD_DEVICE_ORDER_SUCCESS_KEY, "true");
};

export const hasAddDeviceOrderSuccessGate = (): boolean =>
  sessionStorage.getItem(ADD_DEVICE_ORDER_SUCCESS_KEY) === "true";

export const clearAddDeviceOrderSuccessGate = (): void => {
  sessionStorage.removeItem(ADD_DEVICE_ORDER_SUCCESS_KEY);
};
